var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ paddingBottom : '15px' })},[_vm._v("\n\tPrevious migration attempt failed.\n\t\n\t"),_c('a',{staticClass:"proceed",attrs:{"href":"#"},on:{"click":_vm.requeueMigration}},[_vm._v("\n\t\tRetry Migration\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }